import { Component } from '@nicolas-riciotti/light2'
import Tween from '../helpers/Tween.js';

import Lenis from '../helpers/Lenis'

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

export default class WebApplication extends Component {

  created() {

    Lenis.on('scroll', e => {
    });

    console.log('LOCAL', localStorage['accessibility']);

    this.isDebug             = false;
    this.clickSettingsToggle = this.clickSettingsToggle.bind(this);
    // this.siteMotionChange    = this.siteMotionChange.bind(this);
    this.settings = {
      accessibility: {
        enabled:  localStorage['accessibility'] === 'true',//(localStorage.motion === 'reduced-motion' || (!('motion' in localStorage) && window.matchMedia('(prefers-reduced-motion: reduce)').matches)),
        // flag:     'reduced-motion',
        // inversed: false,
        toggles:  null, // populated in attached() from [data-site-settings-type]
      }
    }
  }

  attached() {
    
    document.addEventListener('keydown', e => {
      if (e.ctrlKey && (e.key === 'h' || e.key === 'H')) {
        e.preventDefault();  
        this.isDebug = !this.isDebug;
        this.classList.toggle('is-debug', this.isDebug);
      }
    });

    requestAnimationFrame(()=>{
      this.classList.add('is-ready');
    });

    // On page load (although it is best to add inline in `head` to avoid FOUC).
    for (const [type, setting] of Object.entries(this.settings)) {
      const $els = this.querySelectorAll(`[data-site-settings-type="${type}"]`)
      this.settings[type].toggles = $els;
      console.log('SETTINGS', type, setting.enabled);
      this.updateSetting(type, setting.enabled);
      $els?.forEach($el => {
        $el?.addEventListener('change', this.clickSettingsToggle, false);
      });
    }
    // Respond to OS level settings changes.
    // const motionkModePreference = window.matchMedia('(prefers-reduced-motion: reduce)')
    // motionkModePreference.addEventListener('change', this.siteMotionChange, false)

    // Scroll Anchor smooth anim.
    // Lenis owns the scroll position, so the browser's native #hash jump is
    // suppressed — we must scroll explicitly via Lenis. We also offset by the
    // fixed header so the target doesn't land underneath it.
    const anchors = document.querySelectorAll('a[href*="#"]');
    anchors.forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        const href = this.getAttribute("href");
        const [path, hash] = href.split('#');
        if (!hash) return;
        const currentPath = window.location.pathname;
        if (path === '' || path === currentPath || path === currentPath + '/') {
          const target = document.getElementById(hash);
          if (target) {
            e.preventDefault();
            const header = document.querySelector('app-header');
            const offset = header ? -(header.getBoundingClientRect().bottom + 20) : -120;
            if (typeof Lenis?.scrollTo === 'function') {
              Lenis.scrollTo(target, { offset });
            } else {
              target.scrollIntoView({ behavior: 'smooth' });
            }
            // Move focus for a11y once the scroll settles. Guarded: most
            // section targets have no focusable child.
            setTimeout(() => {
              const focusable = target.querySelector('input, button, a');
              if (focusable) focusable.focus({ preventScroll: true });
            }, 600);
          }
        }
      });
    });

    // For accessibiloty
    document.querySelectorAll('[scroll-into-view]').forEach(link => {
      link.addEventListener('focus', (e) => {
        const section = e.target.closest('article');
        if (section) {
          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    


    document.querySelectorAll('[audio-player-wrapper]').forEach((el, index) => {
      const transcript = el.querySelector('[transcript]');
      if (transcript) {
        // Ensure transcript has a stable id
        if (!transcript.id) {
          transcript.id = `audio-transcript-${index + 1}`;
        }
        // Transcript styling / accessibility defaults
        transcript.classList.add('text-caption');
        transcript.hidden = true;
        transcript.style.marginBottom = '30px';
        transcript.setAttribute('aria-hidden', 'true');
        transcript.setAttribute('role', 'region');
        transcript.setAttribute('aria-label', 'Audio transcript');
        // Add toggle button only once
        let transcriptToggle = el.querySelector('[data-transcript-toggle]');
        if (!transcriptToggle) {
          transcriptToggle = document.createElement('button');
          transcriptToggle.type = 'button';
          transcriptToggle.classList.add('text-caption', 'transcript-button');
          transcriptToggle.style.marginTop = '10px';
          transcriptToggle.style.marginBottom = '10px';
          transcriptToggle.setAttribute('data-transcript-toggle', '');
          transcriptToggle.setAttribute('aria-controls', transcript.id);
          transcriptToggle.setAttribute('aria-expanded', 'false');
          transcriptToggle.textContent = 'Show transcript';
          transcript.parentNode.insertBefore(transcriptToggle, transcript);
          transcriptToggle.addEventListener('click', () => {
            const isHidden = transcript.hidden;
            transcript.hidden = !isHidden;
            transcript.setAttribute('aria-hidden', String(!isHidden));
            transcriptToggle.setAttribute('aria-expanded', String(isHidden));
            transcriptToggle.textContent = isHidden ? 'Hide transcript' : 'Show transcript';
          });
        }
      }
      const obs = new MutationObserver(() => {
        const offscreen = el.querySelector('.mejs-offscreen');
        if (offscreen) {
          offscreen.style.display = 'none';
        }
        const playBtn = el.querySelector('.mejs-play button');
        if (playBtn) {
          playBtn.setAttribute('aria-label', 'Play audio');
          playBtn.innerHTML = `
            <svg class="play-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 27" aria-hidden="true" focusable="false"><path d="M15.871 13.76.498 26.831V.686L15.871 13.76Z"/></svg>
            <svg class="pause-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 27" aria-hidden="true" focusable="false"><path d="M-.024.027h5.701v27.098H-.024zM10.385.045h5.701v27.098h-5.701z"/></svg>
          `;
        }
        const wrapper = el.querySelector('.mejs-container');
        if (wrapper) {
          wrapper.removeAttribute('aria-label');
          wrapper.removeAttribute('tabindex');
          wrapper.removeAttribute('role');
          obs.disconnect();
        }
      });
      obs.observe(el, { childList: true, subtree: true });
    });





    const $searchClear = document.querySelector('[search-clear]');
    const $searchInput = document.querySelector('[search-input]');
    $searchClear?.addEventListener('click', e => {
      $searchInput.value = '';
    });



    document.fonts.ready.then(() => {
      console.log('Fonts loaded');
      requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
          window.dispatchEvent(new Event('resize'));
        });
      });
    });


  }

  clickSettingsToggle(event) {
    const type = event.currentTarget.dataset.siteSettingsType
    const isChecked = ((typeof event.currentTarget.ariaChecked === 'string' && event.currentTarget.ariaChecked === 'true')) ? true : false;
    this.updateSetting(type, !isChecked, true)
  }

  updateSetting(type, enabled, updateLocalStorage = false) {

    localStorage['accessibility'] = enabled;

    this.settings.accessibility.enabled = enabled;

    this.settings.accessibility.toggles?.forEach(toggle => {
      toggle.ariaChecked = enabled ? 'true' : 'false'; 
      toggle.parentNode.classList[ enabled ? 'add' : 'remove' ]('is-checked');
      const $status = toggle.parentNode.querySelector('[site-settings-status]');
      if ($status) {
        $status.textContent = toggle.dataset[ enabled  ? 'checkedStatus' : 'uncheckedStatus' ]
      }
    });
    
    document.documentElement.classList[ enabled ? 'add' : 'remove' ]('accessibility-mode');

    document.dispatchEvent(new CustomEvent(`site_settings_motion`, { detail: enabled ? 'off' : 'on' }));
    document.dispatchEvent(new CustomEvent(`accessibility-mode-change`, { detail: enabled }));
  
  }

  // siteMotionChange(event) {
  //   if (undefined === localStorage['motion']) {
  //     this.updateSetting('motion', event.matches)
  //   }
  // }

}

customElements.define('web-application', WebApplication)

